// src/components/CookieBanner.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../context/GlobalContext';
const CookieBanner = () => {
  const { store, acceptCookie, refuseCookie } = useGlobalContext();
  const { t } = useTranslation();

  const lang = store?.selectedLang || store?.lang || 'fr';
  


  return (
    <div data-ng-controller="cookieController">
      <div className="cookie-acceptance-container bgMainColor">
        <div dangerouslySetInnerHTML={{ __html: store.cookieAcceptance?.[lang] || '' }}></div>
        <div>
          <button onClick={acceptCookie} className="btn buyOther" translate="true">
            {t("Accepter")}
          </button>
          <button onClick={refuseCookie} className="btn buyOther" translate="true">
            {t("Refuser")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
